module.exports = __webpack_public_path__ + "img/anli5.266942fd.png";